import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./assets/fonts/Mulish-Bold.ttf%22,%22weight%22:%22700%22,%22style%22:%22normal%22},{%22path%22:%22./assets/fonts/Mulish-Medium.ttf%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22./assets/fonts/Mulish-Regular.ttf%22,%22weight%22:%22400%22,%22style%22:%22normal%22}]}],%22variableName%22:%22mulish%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'mulish', 'mulish Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
